const configuredApiUrl = process.env.REACT_APP_API_URL?.trim();
const defaultApiUrl =
  process.env.NODE_ENV === "production" ? "" : "http://localhost:3001";

const Connstring = {
  // Production uses same-origin /api requests through IIS. Development uses
  // the local Express server unless REACT_APP_API_URL overrides it.
  connstring: (configuredApiUrl || defaultApiUrl).replace(/\/$/, ""),
  options: {
    encrypt: true,
    trustServerCertificate: true,
  },
};

export default Connstring;
